function decodeTokenPayload(token) {
  try {
    const part = String(token || '').split('.')[1]
    if (!part) return null
    const normalized = part.replace(/-/g, '+').replace(/_/g, '/')
    const padded = normalized + '='.repeat((4 - normalized.length % 4) % 4)
    return JSON.parse(decodeURIComponent(Array.prototype.map.call(atob(padded), c => {
      return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
    }).join('')))
  } catch (e) {
    return null
  }
}

export function authStorageKey(key) {
  const host = (window.location.host || 'local').toLowerCase()
  return `redspider:${host}:${key}`
}

export function getAuthStorageItem(key) {
  return localStorage.getItem(authStorageKey(key)) || localStorage.getItem(key)
}

export function setAuthStorageItem(key, value) {
  localStorage.setItem(authStorageKey(key), value)
}

export function removeAuthStorageItem(key) {
  localStorage.removeItem(authStorageKey(key))
  localStorage.removeItem(key)
}

export function isTokenValid(token) {
  const payload = decodeTokenPayload(token)
  if (!payload || !payload.iat || !payload.exp) return false
  return Number(payload.exp) * 1000 > Date.now()
}

export function clearAuthToken() {
  removeAuthStorageItem('token')
  removeAuthStorageItem('user')
}

export function getValidToken() {
  const token = getAuthStorageItem('token') || ''
  if (!token) return ''
  if (!isTokenValid(token)) {
    clearAuthToken()
    return ''
  }
  return token
}

export function getCustomerShareToken() {
  if (!/^\/customer\/[^/]+\/?$/.test(window.location.pathname || '')) return ''
  return new URLSearchParams(window.location.search || '').get('token') || ''
}

export function redirectToLogin() {
  clearAuthToken()
  if (window.location.pathname !== '/login') window.location.href = '/login'
}
